const MAX_WALK = 100;

export const buildHierarchyIndex = (rows = []) => {
  const inSet = new Set(
    rows
      .map((row) => row.outlineItemId)
      .filter((id) => id != null)
  );
  const parentOf = new Map();
  const childrenOf = new Map();

  for (const row of rows) {
    if (row.outlineItemId == null) {
      continue;
    }
    const parentId =
      row.parentId != null && inSet.has(row.parentId) ? row.parentId : null;
    parentOf.set(row.outlineItemId, parentId);
    if (parentId != null) {
      if (!childrenOf.has(parentId)) {
        childrenOf.set(parentId, []);
      }
      childrenOf.get(parentId).push(row.outlineItemId);
    }
  }

  return { parentOf, childrenOf };
};

export const getDepth = (itemId, parentOf) => {
  if (itemId == null) {
    return 0;
  }
  let depth = 0;
  let current = parentOf.get(itemId);
  while (current != null && depth < MAX_WALK) {
    depth += 1;
    current = parentOf.get(current);
  }
  return depth;
};

export const getDescendants = (itemId, childrenOf) => {
  const result = [];
  if (itemId == null) {
    return result;
  }
  const stack = [...(childrenOf.get(itemId) || [])];
  while (stack.length > 0) {
    const next = stack.pop();
    result.push(next);
    stack.push(...(childrenOf.get(next) || []));
  }
  return result;
};

export const isRowEnabled = (itemId, parentOf, keptIds) => {
  if (itemId == null) {
    return true;
  }
  let current = parentOf.get(itemId);
  let steps = 0;
  while (current != null && steps < MAX_WALK) {
    if (!keptIds.has(current)) {
      return false;
    }
    current = parentOf.get(current);
    steps += 1;
  }
  return true;
};
